import { type FC } from "react";
import { z } from "zod";
import type { InputProps } from "../../DynamicInput";
import { PhoneIcon } from "../../../shared/icons";
import { Text } from "./Text";

const phoneRegex = new RegExp(/^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/);

const phoneNumberParser = z.string().regex(phoneRegex);

export const PhoneNumber: FC<InputProps<string>> = props => {
  return (
    <Text
      {...props}
      Icon={PhoneIcon}
      validation={{
        validator: value => phoneNumberParser.safeParse(value).success,
        errorMessageKey: "DynamicForm.Validation.InvalidPhoneNumber",
      }}
    />
  );
};
